import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import MultiLines from './MultiLines';
import {Tools} from './Tools';
import {Inquiry} from './Inc';
import BottomButtons from './BottomButtons';
import useStyles from './Styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';

interface Props {
    inquiry:Inquiry,
	isOpen:boolean,
    send():void,
    close(): void,
}

const InquiryConfirm: React.FC<Props> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color="primary">お問い合わせの確認</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					この内容でよろしいですか？<br/>
					よろしかったら「送信する」を押して下さい。<br/>
				</div>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>お名前</FormLabel>
							<div className={classes.formValue}>{Tools.stripTags(props.inquiry.name)}</div>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={6}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>お名前（カナ）</FormLabel>
							<div className={classes.formValue}>{Tools.stripTags(props.inquiry.kana)}</div>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>メールアドレス</FormLabel>
							<div className={classes.formValue}>{Tools.stripTags(props.inquiry.mail)}</div>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>お問い合わせ内容</FormLabel>
							<div className={classes.formValue}><MultiLines text={Tools.stripTags(props.inquiry.text)} name="text"/></div>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='送信する' onClick1={props.send} button2="やりなおし" onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default InquiryConfirm;
